/**
 * AppProviders — composición global de providers:
 *   - QueryClientProvider (TanStack Query v5)
 *   - ToastProvider (notificaciones in-app)
 *   - AuthProvider (sesión Supabase, F5 implementa lógica completa)
 *   - ThemeProvider (placeholder — F8 si dark mode)
 *
 * Wrapper único usado por App.
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { ToastProvider } from '../components/ui/ToastProvider';
import { AuthProvider } from './auth-context';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  // Una instancia por render-tree, memoizada para sobrevivir hot-reload.
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
    [],
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>{children}</ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
